<template>
  <el-card class="perf-card" :body-style="{ padding: 0 }" shadow="hover" @click.native="goDetail">
    <div class="perf-card__media">
      <img
        v-if="item.coverImage"
        class="perf-card__cover"
        :src="coverUrl"
        :alt="item.title"
        loading="lazy"
      />
      <div
        v-else
        class="perf-card__cover perf-card__cover--placeholder"
        :style="placeholderStyle"
      >
        <h3 class="perf-card__cover-title">{{ item.title }}</h3>
      </div>
      <span v-if="item.category" class="perf-card__badge">{{ item.category }}</span>
    </div>
    <div class="perf-card__body">
      <h3 class="perf-card__title">{{ item.title }}</h3>
      <p v-if="item.intro" class="perf-card__intro">{{ item.intro }}</p>
      <ul class="perf-card__meta">
        <li v-if="item.venue"><i class="el-icon-location-outline" /> {{ item.venue }}</li>
        <li v-if="item.duration"><i class="el-icon-time" /> {{ item.duration }}</li>
      </ul>
      <span class="perf-card__more">查看详情 →</span>
    </div>
  </el-card>
</template>

<script>
import { resolveImageUrl } from '@/utils/image';

const GRADIENTS = [
  'linear-gradient(135deg, #6b1a2a 0%, #c41e3a 55%, #e8a04a 100%)',
  'linear-gradient(135deg, #3d2b1f 0%, #8b5a2b 55%, #d4a574 100%)',
  'linear-gradient(135deg, #1a3a5c 0%, #2d6a9f 55%, #7eb8da 100%)',
  'linear-gradient(135deg, #0f4c5c 0%, #1b9aaa 55%, #7ed4e6 100%)',
  'linear-gradient(135deg, #4a3728 0%, #8b6914 55%, #c9a227 100%)'
];

export default {
  name: 'PerformanceCard',
  props: {
    item: { type: Object, required: true },
    colorIndex: { type: Number, default: 0 }
  },
  computed: {
    coverUrl() {
      return this.item.coverImage ? resolveImageUrl(this.item.coverImage) : '';
    },
    placeholderStyle() {
      return {
        background: GRADIENTS[this.colorIndex % GRADIENTS.length]
      };
    }
  },
  methods: {
    goDetail() {
      this.$router.push('/performance/' + this.item.id);
    }
  }
};
</script>

<style scoped>
.perf-card {
  margin-bottom: 24px;
  border-radius: 12px;
  overflow: hidden;
  border: none;
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.perf-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(196, 30, 58, 0.1);
}

.perf-card__media {
  position: relative;
  overflow: hidden;
  background: #f5f7fa;
}

.perf-card__cover {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  object-position: center;
  transition: transform 0.35s ease;
}

.perf-card:hover .perf-card__cover {
  transform: scale(1.04);
}

.perf-card__cover--placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.perf-card__badge {
  position: absolute;
  top: 12px;
  left: 12px;
  padding: 4px 12px;
  font-size: 11px;
  color: #fff;
  background: rgba(0, 0, 0, 0.42);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 2px;
  backdrop-filter: blur(4px);
  z-index: 1;
}

.perf-card__cover-title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 4px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  padding: 0 16px;
  text-align: center;
}

.perf-card__body {
  padding: 16px 20px 20px;
}

.perf-card__title {
  margin: 0 0 8px;
  font-size: 17px;
  color: #303133;
}

.perf-card__intro {
  margin: 0 0 12px;
  font-size: 14px;
  color: #606266;
  line-height: 1.75;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.perf-card__meta {
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  font-size: 13px;
  color: #909399;
}

.perf-card__meta li {
  margin-bottom: 4px;
}

.perf-card__meta i {
  margin-right: 4px;
  color: #c41e3a;
}

.perf-card__more {
  font-size: 13px;
  color: #c41e3a;
}

@media (max-width: 768px) {
  .perf-card__cover-title {
    font-size: 20px;
    letter-spacing: 2px;
  }

  .perf-card__body {
    padding: 14px 16px 18px;
  }
}
</style>
